import { TaskEarlyCompletionUnitEnum } from 'graphql-common';
import { subDays, subMonths, subWeeks } from 'date-fns';
import { DateArg, revertTransformDate } from '@lib/utils/dateTimeHelpers';

export default function getEarlyOrderDate(
  deadlineAt: DateArg,
  earlyCompletionUnit: string,
  earlyCompletionAmount: number,
): Date | undefined {
  try {
    if (!deadlineAt || !earlyCompletionUnit || !earlyCompletionAmount) {
      return undefined;
    }
    const normalizedDeadline =
      typeof deadlineAt === 'string'
        ? revertTransformDate(deadlineAt)
        : deadlineAt;
    if (!normalizedDeadline) return undefined;

    if (earlyCompletionUnit === TaskEarlyCompletionUnitEnum.Day) {
      return subDays(normalizedDeadline, earlyCompletionAmount);
    }
    if (earlyCompletionUnit === TaskEarlyCompletionUnitEnum.Week) {
      return subWeeks(normalizedDeadline, earlyCompletionAmount);
    }
    if (earlyCompletionUnit === TaskEarlyCompletionUnitEnum.Month) {
      return subMonths(normalizedDeadline, earlyCompletionAmount);
    }
  } catch (e) {
    console.warn(e);
  }
  return undefined;
}
